var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({attrs:{"color":`${_vm.mappedStatus.color} lighten-4`,"text-color":`${_vm.mappedStatus.color} darken-4`}},'v-chip',_vm.$attrs,false),[_c('span',{staticClass:"px-3 text-capitalize"},[_vm._v(" "+_vm._s(_vm._f("titleCase")(_vm.status ? _vm.$t(`orderStatus.${_vm.status}`) : _vm.$t('common.notAvailable')))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }